import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import Logo from "../components/Logo";
import { Eye, EyeSlash, CheckCircle } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      toast.error("Token faltante");
      return;
    }
    if (password !== password2) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    if (password.length < 6) {
      toast.error("Mínimo 6 caracteres");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      toast.success("Contraseña actualizada");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-app flex items-center justify-center p-4 noise-bg">
      <div className="w-full max-w-md card-base p-8 sm:p-10" data-testid="reset-card">
        <div className="flex flex-col items-center text-center gap-3 mb-8">
          <Logo size={96} />
          <div>
            <div className="font-display font-black text-2xl tracking-tighter uppercase leading-tight">Athlon Sports</div>
            <div className="text-xs text-muted uppercase tracking-widest">Nueva Contraseña</div>
          </div>
        </div>

        {done ? (
          <div className="text-center">
            <CheckCircle size={64} weight="duotone" className="text-[#32D74B] mx-auto mb-4" />
            <h1 className="font-display uppercase font-black text-2xl tracking-tighter mb-3">¡Listo!</h1>
            <p className="text-muted mb-6">Ya podés iniciar sesión con tu nueva contraseña.</p>
            <button onClick={() => navigate("/login")} className="btn-primary w-full" data-testid="go-to-login-btn">
              Iniciar Sesión
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <h1 className="font-display uppercase font-black text-3xl tracking-tighter mb-2">Crear nueva contraseña</h1>
            <p className="text-muted text-sm mb-6">Elegí una nueva contraseña para tu cuenta.</p>
            <div>
              <label className="text-xs uppercase tracking-widest text-muted block mb-2">Nueva contraseña</label>
              <div className="relative">
                <input
                  type={showPwd ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="input-base pr-12"
                  minLength={6}
                  required
                  data-testid="reset-password-input"
                />
                <button type="button" onClick={() => setShowPwd(!showPwd)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted hover:text-white" tabIndex={-1}>
                  {showPwd ? <EyeSlash size={18} weight="bold" /> : <Eye size={18} weight="bold" />}
                </button>
              </div>
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-muted block mb-2">Repetir contraseña</label>
              <input
                type={showPwd ? "text" : "password"}
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                className={`input-base ${password2 && password2 !== password ? "!border-[#FF3B30]" : ""}`}
                minLength={6}
                required
                data-testid="reset-password2-input"
              />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="reset-submit-btn">
              {loading ? "Guardando..." : "Actualizar contraseña"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
